import { Component, OnInit } from '@angular/core';
import { AccountInfo } from '../../../account-info-header/models';
import { selectInfo } from '../../../account-info-header/reducers';
import { Observable, Subject, takeUntil} from 'rxjs';
import { Store } from '@ngrx/store';
import { MasterStatusViewActions } from '../../actions';
import { selectViewInContext } from '../../../shared/reducers';

@Component({
  standalone: false,
  selector: 'mm-master-status-view',
  templateUrl: './master-status-view.component.html',
  styleUrls: ['./master-status-view.component.scss']
})
export class MasterStatusViewComponent {
  accountInfo: AccountInfo;
  destroy$ = new Subject<void>();
  createRequestStep$: Observable<string>;

  constructor(private store: Store) { }


  ngOnInit(): void {
    this.store.select(selectInfo).pipe(takeUntil(this.destroy$)).subscribe(accountInfo => {
      this.accountInfo = accountInfo;
    });

    this.createRequestStep$ = this.store.select(selectViewInContext);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  refresh(masterAccountId: string): void {
      this.store.dispatch(MasterStatusViewActions.refreshMaster({ masterAccountId }));
  }
}
